import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Input, Label } from '@naf/input';
import { breakpoints, spacing } from '@naf/theme';

const StyledForm = styled.form`
  > *:first-child {
    margin-top: 0;
  }
  > *:last-child {
    margin-bottom: 0;
  }
  p {
    margin: 0;
  }
`;

const FieldWrapper = styled.div<{ $isVisible: boolean }>`
  margin-top: 0;
  margin-bottom: ${spacing.space8};

  @media (max-width: ${breakpoints.s}) {
    > div {
      width: 100%;
    }
  }

  input:disabled,
  textarea:disabled {
    font-weight: 400;
    font-style: italic;
    font-size: 16px;
  }

  ${({ $isVisible }) =>
    $isVisible === false &&
    css`
      display: none;
    `}
`;

const StyledInput = styled(Input)<{ width?: 'Wide' | 'Small' }>`
  width: ${(props) => (props.width === 'Wide' ? '100%' : '256px')};

  @media (max-width: ${breakpoints.s}) {
    width: 100%;
  }
`;

const CheckboxWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
`;

const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  > * {
    margin-right: 12px;
  }
`;

const GroupFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-between;

  @media (min-width: ${breakpoints.s}) {
    flex-direction: row;
    > div {
      width: calc(50% - ${spacing.space4});
      label + div {
        width: 100%;
      }
    }
  }
`;

const TextFieldWrapper = styled.div`
  width: 100%;
  > div {
    width: 100%;
  }
`;

const RadioWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.space12};
`;

const TextIfSelectedWrapper = styled.div`
  margin-left: 2rem;
`;

const StyledLabel = styled(Label)`
  p {
    font-weight: 500;
    font-style: normal;
    font-size: 18px;
  }
`;

export default {
  StyledForm,
  FieldWrapper,
  StyledInput,
  CheckboxWrapper,
  ToggleWrapper,
  GroupFieldWrapper,
  TextFieldWrapper,
  RadioWrapper,
  TextIfSelectedWrapper,
  StyledLabel,
};
